import React from 'react';
import PropTypes from 'prop-types';
import { isMobileDevice } from '../../../../../utils/deviceUtils';
import { vmin } from '../../../../../utils/screenUtils';
import { getRandomNumber } from '../../../../../utils/numUtils';

const hiddenCardXOffsets = [2, 4, -1, 7];
const hiddenCardYOffsets = [5, 2, 6, 2];

class VisibleCard extends React.Component {
  static propTypes = {
    card: PropTypes.string,
    allowed: PropTypes.bool,
    gameState: PropTypes.string,
    playCard: PropTypes.func.isRequired,
    currentTurnUid: PropTypes.string,
    memberUid: PropTypes.string,
    selectedCard: PropTypes.string,
    doubleClickSelectedCard: PropTypes.string,
    tableIsInProgress: PropTypes.bool.isRequired,
    cardsLength: PropTypes.number,
    index: PropTypes.number,
    hasPlayedCard: PropTypes.bool,
    hoveredCard: PropTypes.string,
    changeHoveredCard: PropTypes.func.isRequired,
    cardsOnTable: PropTypes.arrayOf(PropTypes.string),
    currentType: PropTypes.string,
    largePlayer: PropTypes.string,
    myPos: PropTypes.string,
    cardsOnLoading: PropTypes.bool,
    defaultCursor: PropTypes.bool,
    isDrunk: PropTypes.bool,
  }

  static defaultProps = {
    card: null,
    allowed: false,
    gameState: null,
    currentTurnUid: null,
    memberUid: null,
    selectedCard: null,
    doubleClickSelectedCard: null,
    cardsLength: 0,
    index: null,
    hasPlayedCard: null,
    hoveredCard: null,
    cardsOnTable: [],
    currentType: null,
    largePlayer: null,
    myPos: null,
    cardsOnLoading: true,
    defaultCursor: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      cardMoveClasses: this.getCardMoveClasses(getRandomNumber(0, 7)),
    };
  }
  
  getCardMoveClasses = (number) => {
    if (number === 0) {
      return ['card2-innerWrapper-drunk-move-up', 'card2-innerWrapper-drunk-move-down']
    }
    else if (number === 1) {
      return ['card2-innerWrapper-drunk-move-left', 'card2-innerWrapper-drunk-move-right']
    }
    else if (number === 2) {
      return ['card2-innerWrapper-drunk-move-down', 'card2-innerWrapper-drunk-move-up']
    }
    else if (number === 3) {
      return ['card2-innerWrapper-drunk-move-right', 'card2-innerWrapper-drunk-move-left']
    }
    else if (number === 4) {
      return ['card2-innerWrapper-drunk-move-up-2', 'card2-innerWrapper-drunk-move-down-2']
    }
    else if (number === 5) {
      return ['card2-innerWrapper-drunk-move-left-2', 'card2-innerWrapper-drunk-move-right-2']
    }
    else if (number === 6) {
      return ['card2-innerWrapper-drunk-move-down-2', 'card2-innerWrapper-drunk-move-up-2']
    }
    else if (number === 7) {
      return ['card2-innerWrapper-drunk-move-right-2', 'card2-innerWrapper-drunk-move-left-2']
    }
  };

  render() {
    const {
      cardsLength,
      card,
      allowed,
      nonPlayable,
      index,
      howerIndex,
      gameState,
      playCard,
      selectedCard,
      tableIsInProgress,
      memberUid,
      currentTurnUid,
      doubleClickSelectedCard,
      hasPlayedCard,
      hoveredCard,
      changeHoveredCard,
      cardsOnTable,
      currentType,
      largePlayer,
      myPos,
      cardsOnLoading,
      hasHiddenCard,
      isVisibleCard,
      defaultCursor,
      isDrunk,
    } = this.props;

    const { cardMoveClasses } = this.state;

    let startIndex = 0;

    let hoveredClass = '';
    if (!nonPlayable && allowed && currentTurnUid === memberUid) {
      if (hoveredCard === `visible-${index}` && !isMobileDevice()) {
        hoveredClass = 'hovered';
      }
    }

    let cardPos = window.innerWidth > 1280 ? {
      left: ((index) - 2) * vmin(24) / 2 - (vmin(2) / 2),
      // transform: `rotate(0deg)`,
      top: 50,
    } : {}

    return (
      <div key={`hover-${card}`} style={{ zIndex: (990 - index) }}>
        {(card && hasHiddenCard) ? (
          <div
            key={`hidden-card-${card}`}
            id={`hidden-card-${card}`}
            style={{...cardPos, pointerEvents: 'none'}}
            className={`card2-wrapper student-zole-hidden-card student-zole-card-${startIndex + index} ${(allowed && gameState && gameState !== 'choose' && gameState !== 'results' && !tableIsInProgress) ? 'allowed2' : 'blocked'}`}
          >
            <div className="card2-innerWrapper" style={{ top: (-10 + hiddenCardYOffsets[index]), right: (5 + hiddenCardXOffsets[index]) }}>
              {card ? (
                <>
                  <div className={cardsOnTable.length === 2 && cardsOnTable && cardsOnTable.includes(card) && gameState && largePlayer && largePlayer === myPos && (gameState === 'burry') && 'take-redesign-card'} />
                  <div className={`card2 card2-on-table card2-hidden ${(selectedCard === card || (doubleClickSelectedCard === card)) ? 'selected' : ''} `} style={defaultCursor ? {cursor: 'default', pointerEvents: 'all'} : {pointerEvents: 'all'} }>
                    <div
                      key={`overlay-${card}`}
                      id={`hand-card-overlay-${card}`}
                      className={`${((!hasPlayedCard && currentTurnUid && memberUid === currentTurnUid && !allowed && gameState && gameState !== 'choose' && !tableIsInProgress)) ? 'blocked-overlay' : 'display-none'}`}
                    />
                  </div>
                </>
              ) : (null)}
            </div>
          </div>
        ) : (null)}

        <div className={`${hoveredClass}`}>
          <div
            key={`visible-card-${card}`}
            id={`hand-card-${card}`}
            style={{ pointerEvents: card ? 'none' : 'none', ...cardPos }}
              className={`${hoveredClass} card2-wrapper student-zole-card-${startIndex + index} ${(allowed && gameState && gameState !== 'choose' && gameState !== 'results' && !tableIsInProgress) ? 'allowed2' : 'blocked'}`}
              onClick={e => playCard(e, { card, allowed: (!nonPlayable && allowed) })}
              onMouseOver={() => changeHoveredCard(`visible-${index}`, card, 'over', (!nonPlayable && allowed))}
              onFocus={() => changeHoveredCard(`visible-${index}`, card, 'over', (!nonPlayable && allowed))}
              onMouseOut={() => changeHoveredCard(`visible-${index}`, card, 'out', (!nonPlayable && allowed))}
              onBlur={() => changeHoveredCard(`visible-${index}`, card, 'out', (!nonPlayable && allowed))}
          >
            <div className={`card2-innerWrapper ${isDrunk && cardMoveClasses[0]} ${isDrunk && 'pulse-blur'}`}>
              {card ? (
                <>
                  <div className={cardsOnTable.length === 2 && cardsOnTable && cardsOnTable.includes(card) && gameState && largePlayer && largePlayer === myPos && (gameState === 'burry') && 'take-redesign-card'} />
                  <div className={`card2 card2-on-table card2-${card} ${(selectedCard === card || (doubleClickSelectedCard === card)) ? 'selected' : ''} `} style={defaultCursor ? {cursor: 'default', pointerEvents: 'all'} : {pointerEvents: 'all'} }>
                    <div
                      key={`overlay-${card}`}
                      id={`hand-card-overlay-${card}`}
                      className={`${((!hasPlayedCard && currentTurnUid && memberUid === currentTurnUid && !allowed && gameState && gameState !== 'choose' && !tableIsInProgress)) ? 'blocked-overlay' : 'display-none'}`}
                      onClick={e => playCard(e, { card, allowed })}
                    />
                  </div>
                </>
              ) : (null)}
            </div>

            {isDrunk && (
              <div className={`aaaa-card2-innerWrapper-test card2-innerWrapper ${cardMoveClasses[1]} pulse-blur`} style={{position: 'absolute', top: 0, left: 0}}>
                {card ? (
                  <>
                    <div className={cardsOnTable.length === 2 && cardsOnTable && cardsOnTable.includes(card) && gameState && largePlayer && largePlayer === myPos && (gameState === 'burry') && 'take-redesign-card'} />
                    <div className={`card2 card2-on-table card2-${card} ${(selectedCard === card || (doubleClickSelectedCard === card)) ? 'selected' : ''} `} style={defaultCursor ? {cursor: 'default', pointerEvents: 'all'} : {pointerEvents: 'all'} }>
                      <div
                        key={`overlay-${card}`}
                        id={`hand-card-overlay-${card}`}
                        className={`${((!hasPlayedCard && currentTurnUid && memberUid === currentTurnUid && !allowed && gameState && gameState !== 'choose' && !tableIsInProgress)) ? 'blocked-overlay' : 'display-none'}`}
                        onClick={e => playCard(e, { card, allowed })}
                      />
                    </div>
                  </>
                ) : (null)}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}


export default (VisibleCard);
